export default class extends Controller {

  connect() {
    App.Helpers.listenToCustomEvent(document, "update-success", this.replaceElementMaybe.bind(this))
    App.Helpers.listenToCustomEvent(document, "calendar--update-success", this.replaceElement.bind(this))
  }

  replaceElementMaybe(event) {
    const { dayReviewID } = event.detail
    if (dayReviewID && this.refreshURL) {
      this.replaceElement(event)
    }
  }

  replaceElement(event) {
    if (this.refreshURL) {
      const { userIDs } = event.detail
      let url = this.refreshURL
      if (userIDs) {
        url = App.Helpers.removeParamsFromURL(url, "user_ids")
        url = App.Helpers.removeParamsFromURL(url, "user_ids[]")
        url = App.Helpers.addParamsToURL(url, { user_ids: userIDs })
      }
      App.Helpers.ajaxRequest({
        url,
        successHandler: this.replaceElementWith.bind(this)
      })
    }
  }

  replaceElementWith(response) {
    App.Helpers.replaceElement(this.element, response)
  }

  get refreshURL() {
    return this.data.get("refresh-url")
  }
}



// WEBPACK FOOTER //
// ./app/components/popups/assets/javascript/popups-activity-alert-links-controller.js